<template>
  <li @click="$emit('setActive')">
    <h4 class="text-xs">
      <svg>
        <use xlink:href="#arrowRight2DarkSvg"></use>
      </svg>
      <span v-accent="item.header">
      </span>
    </h4>
    <p class="text-xs" v-accent="item.subheader"></p>
  </li>
</template>

<script>
export default {
  name: 'eventsNav',
  props: ['item']
}
</script>

<style scoped lang="scss">
  li {
    display: inline-block;
    padding: 0 0 0 73px;
    position: relative;
    cursor: pointer;
  }
  p {
    text-transform: uppercase;
    margin: 7px 0 4px;
    font-weight: 500;
  }
  h4 {
    margin: 18px 0 0;
    font-weight: 500;
  }
  svg {
    width: 10px;
    height: 10px;
    position: absolute;
    top: 22px;
    left: 42px;
  }
  a {
    text-decoration: none;
  }
  .active {
    h4 {
      color: $text-accent;
      // font-weight: 600;
      text-transform: uppercase;
    }
    // p {
    //   font-weight: 600;
    // }
  }
</style>
